import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import getSchema from "../../lib/api/getSchema";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

const BulkAddTranslationButton = (props) => {
    const { t } = useTranslation();

    const { id, refresh, onSuccess, ...others } = props;

    const [open, setOpen] = useState(false);
    const [schema, setSchema] = useState();

    const onOpen = () => {
    setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        let mounted = true;

        const initSchema = async () => {
            const schema = await getSchema("TranslationPath");
            schema.columns = [];

            let column = {};
            column.name = "inputText";
            column.required = true;
            column.formItemType = "text";
            column.multiline = true;
            column.rows = 10;
            column.width = "100%";
            column.formGroup = 0;
            column.formOrder = 1;
            schema.columns.push(column);

            if (mounted) {
                setSchema(schema);
            }
        };

        initSchema();

        return () => {
            mounted = false;
        };
    }, []);

    const onCreateSuccess = (msg) => {
        if (onSuccess) onSuccess(msg);
        refresh.refresh();
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "create-button"}
                onClick={onOpen}
                createButtonName="bulkAddTranslation"
                {...others}
            ></CreateRecordButtonLayout>
            <AutoFormDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={t("dialog.title.BulkAddTranslation.create")}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                modifyUrlCallback={(url) => {
                    return url + "/bulkAddTranslation";
                }}
            />
        </>
    );
};

export default BulkAddTranslationButton;
